import { useTranslation } from 'react-i18next';

import { profilePhotosPendingImageButton } from '@/components/ProfileData/styles.ts';
import ClockShape from '@/components/common/svg/shapes/ClockShape.tsx';

const PhotoStateLabel = () => {
  const { t } = useTranslation();

  return (
    <div style={profilePhotosPendingImageButton}>
      <ClockShape width={12} height={12} fillColor="#fff" />

      <span
        style={{
          fontSize: '10px',
          display: 'inline-block',
          fontWeight: 'bold'
        }}
      >
        {t('photos.state_label')}
      </span>
    </div>
  );
};

export default PhotoStateLabel;
